<template>
    <a-modal v-model="visible" title="实名认证" :footer="null" :width="420" :closable="false" :keyboard="false" :maskClosable="false">
        <div style="font-size:16px;color:#0d253e;text-align:center;">{{des}}</div>
        <div class="spaceCenter" style="margin:24px 0;">
            <a-button type="primary" @click="okModal">立即认证</a-button>
        </div>
    </a-modal>
</template>
<script>
/**
 * 未认证弹窗
 */

export default {
    name:"eleSign",
    data() {
        return {
            visible:false,
            des:undefined,
            type:1,
        };
    },
    methods: {
        open(n){
            this.type = n
            if(n == 1){
                this.des = '您还没有认证通过，请先进行实名认证！'
            }else{
                this.des = '您还没有认证通过，请先进行企业实名认证！'
            }
            this.visible = true;
        },
        close(){
            this.visible = false;
        },
        okModal(btn){
            let url = this.type == 1 ? 'security/editPersonalInfo' : 'security/vertify'
            this.MENUAPI.goToOneTab({
                path: url,

            });
            this.close();
        }
    },
    created() {
    },
    mounted() {}
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/aprv-status/aprv-status-dialog.vue